module.exports = __webpack_public_path__ + "img/tap.a39792ac.png";